// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__NsAZ_","content":"LayoutSettings_content__33jRG"};